import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import { Translate } from "../Translator"
import { ConfigurationApiIntegrationGetSyncState } from "../../ExternalApi/ConfigurationApi"

const MainIntegrationSyncInfo = (props) => {
  
    let mStatusValue = null
    const [mStatus, SetStatus] = useState(null) 
    
    let mTick = 0
    let mEmptyStatusMessages = 0 
    
    useEffect(() => {

        ExecuteInterval() //do not wait for the first interval
        const Interval = setInterval(() => ExecuteInterval(), 1000); 

        return () => clearInterval(Interval);
    }, []); 

    const ExecuteInterval = () =>
    {
        mTick++
        if (mTick % props.CheckSecondsRef.current === 0)
        {
            ConfigurationApiIntegrationGetSyncState(props.SecurityToken, props.IntegrationGuid).then((status) => NewStatus(status))
        }        
    }

    const NewStatus = (aStatus) =>
    {
        console.log("NewStatus: " + JSON.stringify(aStatus))
        if (mStatusValue === null)
        {
            mStatusValue = aStatus
            SetStatus(mStatusValue)

            if (props.CheckSecondsRef.current === 1)
            {
                mEmptyStatusMessages = mEmptyStatusMessages + 1
                if (mEmptyStatusMessages > 10)
                {
                    //Go back to once every 10 seconds
                    console.log("mStatusValue === null | set mCheckSeconds to 10")
                    mEmptyStatusMessages = 0 //clean
                    props.CheckSecondsRef.current = 10
                }
            }
        }
        else if ((aStatus.Busy === mStatusValue.Busy) && (aStatus.UpdateCounter === mStatusValue.UpdateCounter) && (aStatus.StatusMessage === mStatusValue.StatusMessage) && (aStatus.Progress === mStatusValue.Progress))
        {
            if (!aStatus.Busy)
            {
                if (props.CheckSecondsRef.current === 1)
                {
                    mEmptyStatusMessages = mEmptyStatusMessages + 1
                    if (mEmptyStatusMessages > 10)
                    {
                        //Go back to once every 10 seconds
                        console.log("mStatusValue === null | set mCheckSeconds to 10")
                        mEmptyStatusMessages = 0 //clean
                        props.CheckSecondsRef.current = 10
                    }
                }               
            }
        }
        else 
        {
            if (aStatus.UpdateCounter !== mStatusValue.UpdateCounter)
            {
                props.OnIntegrationsRefresh()
            } 
            mStatusValue = aStatus
            SetStatus(mStatusValue)

            mEmptyStatusMessages = -0
            if (props.CheckSecondsRef.current === 10)
            {
                //Go back to once every 10 seconds
                console.log("New update | set mCheckSeconds to 1")
                props.CheckSecondsRef.current = 1
            }
        } 
    }

    const NextUpdateString = (nextUpdateTimeString) => 
    {
        if (nextUpdateTimeString)
        {
            let line = Translate("Automatic synchronization in") + " "

            //const msUntil = Date.parse(nextUpdateTimeString + "+0:00") //This is a utc time. Force it to be recognized as such
            const msUntil = Date.parse(nextUpdateTimeString.replace(' ', 'T') + 'Z')
            const msNow = new Date() //Means now

            let diff = Math.ceil((msUntil - msNow) / 60000)
            if (diff < 2)
            {
                return line + "1 " + Translate("minute")
            }
            else if (diff < 120)
            {
                return line + diff + " " + Translate("minutes")
            }
            else
            {
                diff = Math.ceil(diff / 60)
                if (diff < 48)
                {
                    return line + diff + " " + Translate("hours")
                }
                else
                {
                    diff = Math.ceil(diff / 24)
                    return line + diff + " " + Translate("days")
                }
            } 
        }
        else if (!props.AutoSync)
        {
            return Translate("Automatic synchronization disabled")
        }
        else
        {
            return Translate("Next synchronization could not be determined")
        } 
    }

    let SyncText = null
    if (mStatus && mStatus.Busy)
    {
        SyncText = (mStatus.StatusMessage ? mStatus.StatusMessage + " " : "") + (mStatus.Progress ? mStatus.Progress : "")
    }

    return (
        <span>
            {(SyncText !== null) ? <div>{SyncText}</div> :
                (!props.LastSynced ? <div>{Translate("First synchronization is being scheduled")}</div> : 
                    <div>{NextUpdateString(props.NextSync)}</div>)}

            {(SyncText === null) ? <div className="errortext">{props.LastError}</div> : <div/>}                    
        </span>
    );
}

MainIntegrationSyncInfo.propTypes = {
  SecurityToken: PropTypes.string,
  IntegrationGuid: PropTypes.string,
  AutoSync: PropTypes.bool,
  NextSync: PropTypes.string,
  LastSynced: PropTypes.string,
  LastError: PropTypes.string,
  CheckSecondsRef: PropTypes.object,
  OnIntegrationsRefresh: PropTypes.func
}

export default MainIntegrationSyncInfo